import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const WhatsAppComponentTable1 = () => {
  const cellStyle = {
    border: "1px solid #ccc",
    padding: "14px",
    fontSize: "15.5px",
    fontFamily: "'Roboto', sans-serif",
  };

  const rows = [
    {
      component: "Header (Text)",
      description: "Short text line at top",
      character_limit: "(≤ 60 chars)",
      supported: "✓ (emojis supported)",
    },
    {
      component: "Header (Media)",
      description: "Image, Video, Sticker or Document (no caption)",
      character_limit: "-",
      supported: "✓ (media only; no text or emojis)",
    },
    {
      component: "Body Text",
      description: "Main message copy",
      character_limit: "(≤ 1,024 chars)",
      supported: "✓ (emojis supported)",
    },
    {
      component: "Footer Text",
      description: "Optional helper text",
      character_limit: "(≤ 60 chars)",
      supported: "✓ (emojis supported)",
    },
    {
      component: "CTA Button (URL)",
      description: "HTTPS link opened on tap",
      character_limit: "(≤ 2,000 chars)",
      supported: "✓ (must be a valid URL; no emojis)",
    },
    {
      component: "Quick-Reply Buttons",
      description: "Reply options that send back a payload",
      character_limit: "-",
      supported: "✗",
    },
    {
      component: "List Messages",
      description: "Scrollable list of selectable options",
      character_limit: "-",
      supported: "✗",
    },
    {
      component: "Additional Media Attachments",
      description: "Sending media outside the header",
      character_limit: "-",
      supported: "✗ (only header media allowed)",
    },
    {
      component: "Emojis",
      description: "Use of emojis within your message or labels",
      character_limit: "-",
      supported: "✓ in header/body/footer text & ✗ in button/URL",
    },
    {
      component: "Availability",
      description:
        "Supported in all WhatsApp Cloud API–enabled countries (including India; over 180 in total)",
      character_limit: "-",
      supported: "✓",
    },
  ];

  return (
    <Box sx={{ borderRadius: 2, boxShadow: 3, overflow: "hidden" }}>
      <TableContainer component={Paper}>
        <Table
          sx={{
            minWidth: 700,
            borderCollapse: "collapse",
          }}
        >
          <TableHead sx={{ backgroundColor: "#f4f6f8" }}>
            <TableRow>
              <TableCell sx={{ ...cellStyle, fontWeight: 600, fontSize: "18px" }}>
                Component
              </TableCell>
              <TableCell sx={{ ...cellStyle, fontWeight: 600, fontSize: "18px" }}>
                Description
              </TableCell>
              <TableCell sx={{ ...cellStyle, fontWeight: 600, fontSize: "18px",  textAlign: "center" }}>
                Character Limit
              </TableCell>
              <TableCell sx={{ ...cellStyle, fontWeight: 600, fontSize: "18px" , textAlign: "center" }}>
                Supported?
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow
                key={idx}
                sx={{
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                }}
              >
                <TableCell sx={cellStyle}>{row.component}</TableCell>
                <TableCell sx={cellStyle}>{row.description}</TableCell>
                <TableCell sx={{ ...cellStyle, textAlign: "center" }}>
                  {row.character_limit}
                </TableCell>
                <TableCell sx={{ ...cellStyle, textAlign: "center" }}>
                  {row.component === "Emojis" ? (
                    <>
                      <Typography component="span" sx={{ color: "green", fontWeight: 600 }}>
                        ✓ in header/body/footer text
                      </Typography>{" "}
                      &{" "}
                      <Typography component="span" sx={{ color: "red", fontWeight: 600 }}>
                        ✗ in button/URL
                      </Typography>
                    </>
                  ) : (
                    <Typography
                      component="span"
                      sx={{
                        color: row.supported.includes("✓")
                          ? "green"
                          : row.supported.includes("✗")
                          ? "red"
                          : "inherit",
                        fontWeight: 600,
                      }}
                    >
                      {row.supported}
                    </Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default WhatsAppComponentTable1;
